<template lang="html">
  <div>
    <div id="pendingSidebar" :class='{"sideBar": true, "fade-in": showToggleButton}' @mouseenter='openSideBar'>
      <i class="fa fa-bars primary-green-text left"></i>
    </div>
    <side-bar
      :show='sideBarToggle'
      :fetchAggregatedOffer='fetchAggregatedOffer'
      :submitButtonPresent='true'
      :type='popUptype'
      :sidebarHeader='sideBarTitle'
      @sidebarInactive='closeSideBar'
    >
    </side-bar>
    <div class="outer-div-min" id="outerDivMinId">
      <div class="inner-div text-center" id='selectedOffersInnerDiv'>
        <div v-if="this.fixedTableData.length > 0">
          <div style="table-layout: fixed; overflow-y: scroll">
            <table style="margin: 0 auto">
              <tr>
                <th>CLASSIFIED BY TOOL</th>
                <th>GREEN</th>
                <th>YELLOW</th>
                <th>RED</th>
                <th>TOTAL</th>
              </tr>
              <tr v-for="row in fixedTableData">
                <td
                  v-for="(column, i) in row"
                  :class="{'primary-green-text': column.data.others && column.data.others.clickable, 'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0}"
                  @click="childEvent(column.data)"
                  >{{column.data.value}}
                </td>
              </tr>
            </table>
          </div>
          <div :class="{'table-two-parent': true, 'beforeCollpaseHeight': !getterNavBarCollapse, 'afterCollapseHeight': getterNavBarCollapse}">
            <table style="margin: 0 auto">
              <tr v-for="row in scrollableTableData">
                <td
                  v-for="(column, i) in row"
                  :class="{'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0}">
                  <template v-for="value in getCellRecord(column.data.value)">
                    <span :class="{'red-text': value.length > 1 && (/^[-][^a-zA-Z]+$/g.test(value)), 'margin-right': value === '(', 'margin-left': value === ')'}">
                      {{ value }}
                    </span>
                  </template>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div v-else class='preview'>
          <h2 class='grey-text'>{{ defaultNote }}</h2>
        </div>
        <div class='text-center' :style="{'margin-top': '1rem'}">
          <button
            type="button"
            :class="{'width_3': true, 'primary-green-bg': true}"
            @click="downloadPortalGuide">
            Download Portal Guide
          </button>
          <button
            type="button"
            :class="{'width_3': true, 'primary-green-bg': true}"
            @click="downloadManufacturerInfo">
            Download Manufacturer Info
          </button>
          <button
            type="button"
            :class="{'width_3': true, 'primary-green-bg': true}"
            @click="downloadNegativeMarginItems">
            DOWNLOAD NEGATIVE MARGIN ITEMS
          </button>
          <button
            type="button"
            :disabled="buttonDisabled"
            :class="{'width_3': true, 'primary-green-bg': !buttonDisabled}"
            @click="downloadAllDetails">
            Download Selected Period Data
          </button>
            <!-- <button
            type="button"
            :class="{'width_3': true, 'primary-green-bg': !buttonDisabledTemp}"
            @click=""
            :disabled='buttonDisabledTemp'>
            Download Promo Items Sales Forecast
          </button> -->
          <button
            v-if='isLoginSuperUser'
            type="button"
            :class="{'width_3': true, 'primary-green-bg': !buttonDisabled}"
            :disabled='!isLoginSuperUser || buttonDisabled'
            @click="sendMail()">
            Send Final Confirmation Mail
          </button>
        </div>
      </div>
    </div>
    <!-- <stickyNotifications>
      All Classifications are made on Mock data
    </stickyNotifications> -->
  </div>
</template>

<script>
import { tableStyles } from './tableStyles'
import DataTable from 'src/components/shared/flexTables/DataTable'
import SideBar from 'src/components/shared/SideBar'
import stickyNotifications from 'src/components/shared/stickyNotifications'
import { mapActions, mapGetters } from 'vuex'
import * as NameSpace from 'src/store/NameSpace'
import { TableHeightByFixedWidth } from 'src/Services/tableLayoutHelper/height'
import { isSuperUser, getVendorId } from 'src/components/shared/helper/superUser'

export default {
  data () {
    return {
      tableStyles,
      scrollableWidth: '0px',
      scrollableChildrenWidth: 0,
      headerWidth: 0,
      sideBarToggle: true,
      popUptype: 'pendingApprovals',
      sideBarTitle: 'Filter Section',
      type: 'record',
      nextRouterPath: '/pending-offers/selected-offers',
      // nextRouterName: 'selectedPendingOffers',
      buttonDisabled: true,
      buttonDisabledTemp: true,
      defaultNote: 'Data will be displayed here once you submit data from sidebar.',
      showToggleButton: false,
      isLoginSuperUser: false,
      scrollableTableWidth: '100rem',
      marginLeft: 0
    }
  },
  methods: {
    ...mapActions({
      fetchPendingOffer: NameSpace.ACTION_PENDING_APPROVALS,
      setSelectedAggData: NameSpace.ACTION_SELECTED_AGG_DATA,
      actionDownloadAllDetails: NameSpace.ACTION_DOWNLOAD_ALL_DETAILS,
      actionDownloadManufacturerInfo: NameSpace.ACTION_DOWNLOAD_MANUFACTURER_INFO,
      actionDownloadNegativeMarginItems: NameSpace.ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS,
      actionDownloadDax: NameSpace.ACTION_DOWNLOAD_DAX,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION,
      sendConfiramtionMail: NameSpace.ACTION_SEND_CONFIRMATION_MAIL,
      resetPendingData: NameSpace.RESET_PENDING_APPROVALS,
      downloadPortalGuide: NameSpace.ACTION_DOWNLOAD_PORTAL_GUIDE
    }),
    // isMerchantChoosen () {
    //   if (this.isLoginSuperUser) {
    //     let merchant = this.getSelectedMerchant
    //     if (merchant && merchant !== CLEAR_FILTER) {
    //       console.log(merchant)
    //       return true
    //     }
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    downloadManufacturerInfo () {
      let payload = {}
      if (this.isLoginSuperUser) {
        let merchant = this.getSelectedMerchant
        if (merchant && merchant.value !== undefined) {
          payload.merchantId = merchant.value
        }
      }
      this.actionDownloadManufacturerInfo(payload)
    },
    //  change
    downloadNegativeMarginItems () {
      let payload = {}
      if (this.isLoginSuperUser) {
        let merchant = this.getSelectedMerchant
        if (merchant && merchant.value !== undefined) {
          payload.merchantId = merchant.value
        }
      }
      this.actionDownloadNegativeMarginItems(payload)
    },
    //  change
    getCellRecord (record) {
      let splittedArray = record.split(' ')
      let arrayResult = []
      for (let i = 0; i < splittedArray.length; i++) {
        let text = splittedArray[i]
        if (text.includes('-')) {
          let indexOfMinus = text.indexOf('-')
          let part1 = text.substring(0, indexOfMinus)
          if (part1) {
            arrayResult.push(part1)
          }
          let part2 = text.substring(indexOfMinus, text.length)
          if (part2) {
            let part2Index = part2.indexOf(')')
            let first = part2.substring(0, part2Index)
            if (first) {
              arrayResult.push(first)
            }
            let second = part2.substring(part2Index, part2.length)
            if (second) {
              arrayResult.push(second)
            }
          } else {
            arrayResult.push(part2)
          }
        } else {
          arrayResult.push(text)
        }
      }
      return arrayResult
    },
    getScrollableWidth () {
      if (
        this.fixedTableData.length > 0 &&
        document.getElementById('selectedOffersInnerDiv') &&
        document.getElementById('selectedOffersFixedHeaderContainer') &&
        document.getElementById('selectedOffersScrollableHeaderContainer')
      ) {
        let selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth
        let selectedOffersFixedHeaderContainer = document.getElementById('selectedOffersFixedHeaderContainer').clientWidth
        let selectedOffersScrollableHeaderContainer = document.getElementById('selectedOffersScrollableHeaderContainer').clientWidth
        let selectedOffersHeaderContainer = Math.max(selectedOffersFixedHeaderContainer, selectedOffersScrollableHeaderContainer)
        this.headerWidth = selectedOffersHeaderContainer
        let paddingOnInnerDiv = 50

        this.modifyTableHeightByData('#offersListScrollableX div div')
        this.modifyTableHeightByData('#selectedOffersScrollableHeaderContainer')
        return selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv
      }
    },
    modifyTableHeightByData (el) {
      let tableHeightAdjustment = new TableHeightByFixedWidth(
        this.scrollableTableData,
        this.scrollableChildrenWidth,
        '1.5rem',
        '1rem'
      )
      let outerDivMinWidth = document.getElementById('outerDivMinId').clientWidth
      this.scrollableTableWidth = document.getElementById('fixedContanerId').clientWidth
      this.marginLeft = (outerDivMinWidth - this.scrollableTableWidth - 40) / 2
      // this.navBarCollapseState = document.getElementById('logPart1Id').clientHeight
      // console.log(this.navBarCollapseState)
      if (this.scrollableTableData && this.scrollableTableData.length) tableHeightAdjustment.modifyTableRowHeight(el)
    },
    openSideBar (e) {
      this.sideBarToggle = true
      this.showToggleButton = false
    },
    closeSideBar (e) {
      this.showToggleButton = true
      this.sideBarToggle = false
    },
    childEvent (record) {
      // this.$router.push(this.nextRouterPath)
      const { value, others } = record
      let update = {}
      update.makeLink = others.clickable
      update.object = others.itemToOfferMapping
      update.status = others.status
      update.value = value
      if (others.clickable) {
        this.setSelectedAggData(update)
        // this.$router.push({ name: this.nextRouterName, params: record })
        this.$router.push(this.nextRouterPath)
      }
    },
    fetchAggregatedOffer (input) {
      if (isSuperUser()) {
        this.isLoginSuperUser = true
        let vendor = getVendorId()
        if (vendor) {
          input.manufacturerId = vendor.value
        }
      }
      let merchant = this.getSelectedMerchant
      if (merchant) {
        input.merchantId = merchant.value
      }
      this.fetchPendingOffer(input)
    },
    getPendingApprovals (object) {
      let obj = {}
      if (object.offers) {
        obj.offers = object.offers.id
      }
      if (object.period) {
        obj.period = object.period.id
      }
      if (object.department) {
        obj.departmentId = object.department.id
      }
      if (object.subDeparmethodstment) {
        obj.subDepartmentId = object.subDepartment.id
      }
      if (object.class) {
        obj.classId = object.class.id
      }
      if (object.subClass) {
        obj.subClassId = object.subClass.id
      }
      if (object.brand) {
        obj.brandId = object.brand.id
      }
      if (object.storeLevel) {
        obj.storeLevel = object.storeLevel.id
      }
      // console.log('In submit of created:', obj)
      this.fetchAggregatedOffer(obj)
    },
    downloadAllDetails () {
      let obj = this.gettersAggInputDataId
      this.actionDownloadAllDetails({offerCategory: obj.offers.id, period: obj.period.id})
    },
    downloadDax () {
      let obj = this.gettersAggInputDataId
      this.actionDownloadDax({period: obj.period.id})
    },
    sendMail () {
      this.pop({
        header: 'CONFIRMATION',
        message: 'Are you sure to send mail?',
        buttons: {
          accept: {
            text: 'OKAY',
            action: this.sendAcceptMail.bind(this)
          },
          decline: {
            text: 'CANCEL',
            present: true
          }
        }
      })
    },
    sendAcceptMail () {
      let obj = this.gettersAggInputDataId
      this.sendConfiramtionMail({period: obj.period.id})
    }
  },
  mounted () {
    // document.getElementsByClassName('scroll')[0].addEventListener('scroll', () => {
    //   this.navBarCollapseState = 0
    // }, false)
    this.scrollableWidth = this.getScrollableWidth()
  },
  beforeDestroy () {
    this.resetPendingData()
  },
  created () {
    if (isSuperUser()) {
      this.isLoginSuperUser = true
    }
    let windowWidth = window.innerWidth
    if (windowWidth > 900 && windowWidth < 1200) {
      this.scrollableChildrenWidth = 12
    }
    if (windowWidth > 1200 && windowWidth < 1400) {
      this.scrollableChildrenWidth = 16
    }
    if (windowWidth > 1400 && windowWidth < 1600) {
      this.scrollableChildrenWidth = 24
    }
    if (windowWidth > 1600 && windowWidth < 2400) {
      this.scrollableChildrenWidth = 30
    }
    let obj = this.gettersAggInputDataId
    if (Object.keys(obj).length) {
      this.getPendingApprovals(obj)
    }
  },
  updated () {
    this.$nextTick(function () {
      this.scrollableWidth = this.getScrollableWidth()
    })
  },
  watch: {
    scrollableTableData () {
      if (this.scrollableTableData && this.scrollableTableData.length) {
        this.buttonDisabled = false
      }
    },
    'gettersDownloadError' () {
      this.pop({
        header: 'Download Failed!',
        message: this.gettersDownloadError,
        type: 'ERROR'
      })
    },
    getterConfiramtionMailResponse () {
      if (this.getterConfiramtionMailResponse) {
        this.pop({
          header: 'RESULT',
          message: this.getterConfiramtionMailResponse
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      fixedTable: NameSpace.GET_AGGREGATED_FIX_TABLE,
      scrollableTable: NameSpace.GET_PENDING_AGGREGATED_SCROLLABLE_TABLE,
      gettersAggInputDataId: NameSpace.GET_AGG_INPUT_FILTER_ID,
      gettersDownloadError: NameSpace.GET_DOWNLOAD_ERROR,
      getterConfiramtionMailResponse: NameSpace.GETTER_CONFIRMATION_MAIL_RESPONSE,
      getterNavBarCollapse: NameSpace.GET_NAV_BAR_COLLAPSE,
      getSelectedMerchant: NameSpace.GET_SELECTED_MERCHANT
    }),
    // fixedTableHeaders () {
    //   return this.fixedTable.headers
    // },
    fixedTableData () {
      return this.fixedTable
    },
    // scrollableTableHeaders () {
    //   return this.scrollableTable.headers
    // },
    scrollableTableData () {
      return this.scrollableTable
    }
  },
  components: {
    DataTable,
    SideBar,
    stickyNotifications
  }
}
</script>

<style lang="css" scoped>
  .margin-left {
    margin-left: -4px
  }
  .margin-right {
    margin-right: -4px
  }
  .table-two-parent {
    margin-top: 0.5rem;
    height: 200px;
    overflow-y: scroll;
    table-layout: fixed;
  }
  .fix-header-width {
    padding: 0.8rem 1rem 0.8rem 1rem;
    width: 500px;
    background-color: rgb(246, 246, 230);
  }
  .fix-data-width {
  }
  .primary-green-text {
    color: #00AF41;
    cursor: pointer;
    font-weight: bold;
  }
  table, th, td {
    border: 1px solid black;
    word-break: break-all;
    font-size: 1.3rem;
    border-color: #cfc9c9;
    border-collapse: collapse;
  }
  th {
    background-color: rgb(230, 232, 246);
    padding: 1rem;
    color: #443c3c;
  }
  .padding-right {
    padding-right: 3%;
  }
  button {
    font-size: 1rem;
    padding: 0.6rem 1.5rem;
  }
  .left-align {
    text-align: left;
  }

  .v-top {
    vertical-align: top;
  }

  .preview {
    text-align: center;
    background: #eee;
    padding: 0.5rem 0;
    margin: 0.5rem 0;
    border-radius: 0.2rem;
    border: 0.1rem solid #ccc;
  }
  .margin-fix {
    margin-left: -.5rem;
  }
  .scrollable-x {
    overflow-x: auto;
  }
  .scrollable {
    overflow: auto;
  }
  .vertical-top {
    vertical-align: top;
  }
  .sideBar {
    background-color: #fff;
    padding: 0.5rem 1rem;
    box-shadow: 0 0 0.5rem #777;
    position: fixed;
    top: 0.4rem;
    left: 0.4rem;
    z-index: 10;
    opacity: 0;
    cursor: pointer;
    font-size: 1.5rem;
    transition: 2s;
  }
  .fade-in {
    opacity: 1;
  }
  .hide {
    display: none;
  }
  #selectedOffersInnerDiv > * {
    position: relative;
  }
  .inline-block.margin-fix.v-top table {
    text-align: center;
  }
  .inline-block, inline-block.v-top table {
    text-align: left;
  }
  [class*='grid-']:last-of-type {
    padding-left: 22px;
  }
  @media only screen and (min-width: 576px) {
    .beforeCollpaseHeight {
      height: 10rem;
    }
    .afterCollapseHeight {
      height: 12rem;
    }
  }

  @media only screen and (min-width: 768px) {
    .beforeCollpaseHeight {
      height: 5rem;
    }
    .afterCollapseHeight {
      height: 14rem;
    }
    .cell-data-width {
      width: 8rem;
    }
  }

  @media only screen and (min-width: 992px) {
    .beforeCollpaseHeight {
      height: 8rem;
    }
    .afterCollapseHeight {
      height: 12rem;
    }
    .cell-data-width {
      width: 10rem;
    }
  }

  @media only screen and (min-width: 1200px) {
    .beforeCollpaseHeight {
      height: 14rem;
    }
    .afterCollapseHeight {
      height: 20rem;
    }
    .cell-data-width {
      width: 16rem;
    }
  }

  @media only screen and (min-width: 1500px) {
    .beforeCollpaseHeight {
      height: 23rem;
    }
    .afterCollapseHeight {
      height: 28rem;
    }
    .cell-data-width {
      width: 22rem;
    }
  }
  @media only screen and (min-width: 1900px) {
    .beforeCollpaseHeight {
      height: 36rem;
    }
    .afterCollapseHeight {
      height: 40rem;
    }
    .cell-data-width {
      width: 30rem;
    }
  }
  @media only screen and (min-width: 2500px) {
    .beforeCollpaseHeight {
      height: 40rem;
    }
    .afterCollapseHeight {
      height: 45rem;
    }
    .cell-data-width {
      width: 38rem;
    }
  }
</style>



// WEBPACK FOOTER //
// PendingApproval.vue?257302f7